import zod from "zod";

export const schema = zod.object({
	password: zod
		.string()
		.trim()
		.min(8, "Deve ter no mínimo 8 caracteres")
		.transform((data) => (!data?.length ? undefined : data)),
	token: zod.string().nullable(),
});

export type RecoverPasswordFormType = zod.infer<typeof schema>;
